// Cambia el logo del header al hacer scroll añadiendo/removiendo una clase al header
export default function initHeaderLogoSwap() {
    const header = document.getElementById('app-header');
    if (!header) return;
    const onScroll = () => {
        if (window.scrollY > 10) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    // Ejecutar al cargar
    onScroll();
}
